import cn from 'classnames';
import React from 'react';

import { SelectSimple, FormErrors, Spinner, FormField } from '@mssgme/ui';
import { useVkIntegration } from './useVkIntegration';

import styles from '../commonStyles.scss';

function VKIntegration() {
    const {
        t,
        vk,
        plugError,
        step,
        handleLoginClick,
        handleSubmit,
        username,
        selectedGroup,
        getGroupsOptions,
        handleChange,
        errors,
        isFetching,
    } = useVkIntegration();

    if (!vk) {
        return plugError && <FormErrors error={t(plugError)} />;
    }

    switch (step) {
        case 1:
            return (
                <div className={styles.rootContainer}>
                    <p>{t('vkIntegration.step1.heading')}</p>
                    <div className={styles.buttonContainer}>
                        <button className={cn(styles.submitButton, styles.active)} onClick={handleLoginClick}>
                            {t('vkIntegration.step1.sign_in_vk')}
                        </button>
                    </div>
                </div>
            );
        case 2:
            return (
                <form onSubmit={handleSubmit} className={styles.root}>
                    <p style={{ marginBottom: 10 }}>
                        {t('vkIntegration.step2.status')}&nbsp;<strong>{username}</strong>
                    </p>
                    <p style={{ marginBottom: 20 }}>{t('vkIntegration.step2.heading')}</p>
                    <FormField
                        component={SelectSimple}
                        inputClassName={styles.groups}
                        placeholder={t('vkIntegration.step2.select_group')}
                        value={(selectedGroup && selectedGroup.id) || ''}
                        options={getGroupsOptions()}
                        onChange={handleChange}
                        errors={errors.selectedPage}
                    />
                    <div className={styles.buttonContainer}>
                        <button
                            type="submit"
                            className={cn(styles.submitButton, {
                                [styles.active]: !!selectedGroup,
                                [styles.isFetching]: isFetching,
                            })}
                        >
                            {isFetching ? (
                                <Spinner size="16" color="white" className={styles.spinner} />
                            ) : (
                                t('vkIntegration.step2.connect')
                            )}
                        </button>
                    </div>
                </form>
            );
    }
}

export default VKIntegration;
